import { ModelSagres } from "../../model-sagres";
import { Contrato } from "./contrato";

export class ParticipanteContrato extends ModelSagres {
  IdParticipanteContrato: number;
  IdContrato: number;
  CdCpfCnpjParticipante: string;
  VlParticipacao?: number;
  NmParticipante: string;
  FlConsorcio: string;
  TldParticipante: string// = "BR";

  IdContratoNavigation: Contrato;
}
